import React, { Component } from 'react'
import { connect } from 'react-redux'

import '../style/specialOfferContactUs.scss'

import NumberFormat from 'react-number-format'

import Alert from './Alert'
import Loader from './Loader'

import { setInput, submitForm } from '../store/actions/OfferContactUsActions'

class SpecialOfferContactUs extends Component {

    /*state = {
        submit: {
            didSubmit: false,
            error: false,
            errorMessage: "",
        },
        name: "",
        phone: "",
        email: "",
    }*/

    setInput(e, id) {
        /*this.setState({
            ...this.state,
            [id]: e.target.value,
        })*/
        this.props.setInput(e.target.value, id);
    }

    submitForm(e) {
        e != undefined && e.preventDefault();
        this.props.submitForm();
        /*const { submit, name, phone, email } = this.state;
        if(submit.didSubmit) return;
        if(isStringEmail(email) && name.length >= 3 && isStringPhone(phone)) {
            this.setState({
                ...this.state,
                submit: {
                    ...this.state.submit,
                    didSubmit: true,
                    error: false,
                    errorMessage: "",
                }
            })
        } else {
            this.setState({
                ...this.state,
                submit: {
                    ...this.state.submit,
                    didSubmit: false,
                    error: true,
                    errorMessage: 
                        !isStringPhone(phone) ? "Please enter a valid phone number" :
                            (
                            !isStringEmail(email) ? "Please enter a valid email address" :
                                (name.length < 3 ? "Please enter your full name" : "Unknown error occurred.")
                            ),
                }
            })
        }*/
    }

    render() {
        const { name, email, phone, submit } = this.props.data;
        
        return (
            <div id="special-offer">
                <div className="title">You might be eligible for <b>special pricing.</b> Request Here</div>
                <div>
                    <div id="inputs-holder">
                        <form onSubmit={(e) => this.submitForm(e)}>
                            <input typeof="submit" placeholder="Full Name" value={name} onChange={(e) => this.setInput(e, "name")} />
                        </form>
                        <form onSubmit={(e) => this.submitForm(e)}>
                            <NumberFormat
                                format="+1 ### ### ####" mask="_"
                                placeholder="Phone Number" 
                                value={phone} 
                                onChange={(e) => this.setInput(e, "phone")} />
                        </form>
                        <form onSubmit={(e) => this.submitForm(e)}>
                            <input type="email" placeholder="Email Address" value={email} onChange={(e) => this.setInput(e, "email")} />
                        </form>
                    </div>
                    <div className="btns-holder" onSubmit={() => this.submitForm()}>
                        {
                            submit.didSubmit ?
                            (
                                <Alert type="SUCCESS">
                                    <div className="sub-title">
                                        Thank You, we will contact you as soon as we can.
                                    </div>
                                </Alert>
                            )
                            :
                            (
                                <div>
                                    {submit.error && (
                                        <Alert type="DANGER">
                                            <div className="sub-title">
                                                {submit.errorMessage}
                                            </div>
                                        </Alert>
                                    )}
                                    <div className="btns-holder">
                                        {
                                            submit.isSubmitting ? 
                                            <Loader isVisible={true} />
                                            :
                                            <div className="btn" onClick={() => this.submitForm()}>Submit</div>
                                        }
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div>
                    <div className="title" style={{margin: "1.5vh .5vw"}}>Or feel free to contact us.</div>
                    <div id="links-holder">
                        <div className="sub-title">Our Phone Number: <a href="tel:18558342546">855-VDialing (855-834-2546)</a></div>
                        <div className="sub-title">Our Email: <a href="mailto:sales@voipdialing.com">sales@voipdialing.com</a></div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        data: state.OfferContactUsReducer,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        setInput: (value, id) => dispatch(setInput(value, id)),
        submitForm: () => dispatch(submitForm()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialOfferContactUs);